import { call, put, select } from 'redux-saga/effects';

import { OperationStatus } from '@pressreader/appstore';
import { error } from '@pressreader/logger';
import { showAlertFromResourceKey } from '@pressreader/popups-alert';
import { loadAllTemplates } from '@pressreader/resources';
import { legacyAppLoadBegan, legacyAppLoadDone, legacyAppLoadFailed, selectLegacyAppStatus } from '@pressreader/views-common';

let legacyModule: any = null;

async function loadViewerLegacyModule(canRetry = true) {
    try {
        const importTask = import(/* webpackChunkName: "viewer.legacy" */ 'init.web');
        const m = await importTask;
        await m.runInit();

        return m;
    } catch (err) {
        error(err);
        if (canRetry) {
            return loadViewerLegacyModule(false);
        } else {
            throw err;
        }
    }
}

async function loadLegacyBookmarkEditDialog() {
    const { default: bookmarkEditDialog } = await import(/* webpackChunkName: "viewer.legacy" */ 'bookmarks/bookmark.edit.dialog');
    return bookmarkEditDialog;
}

async function loadLegacyPrintingCode() {
    const { default: ndPrinting } = await import(/* webpackChunkName: "viewer.legacy" */ 'nd.printing');
    return ndPrinting;
}

function* loadLegacyApp(): GeneratorResult<boolean> {
    if (legacyModule) {
        return true;
    }
    const status = yield select(selectLegacyAppStatus);
    if (status === OperationStatus.Pending) {
        return false;
    }

    yield put(legacyAppLoadBegan());

    try {
        legacyModule = yield call(loadViewerLegacyModule);
        yield call(loadAllTemplates);
        yield put(legacyAppLoadDone());

        return true;
    } catch (err) {
        yield put(legacyAppLoadFailed());

        yield showAlertFromResourceKey('App.LegacyApp.Load.Error');
    }

    return false;
}

async function resolveLegacyCurrentUrl() {
    try {
        const importTask = import(/* webpackChunkName: "viewer.legacy" */ 'nd.viewer.resolve.current.url');
        const m = await importTask;
        await m.resolveCurrentUrl();

        return m;
    } catch (err) {
        error(err);
    }
}

export { loadLegacyApp, loadLegacyBookmarkEditDialog, loadLegacyPrintingCode, loadViewerLegacyModule, resolveLegacyCurrentUrl };
